import { action } from 'typesafe-actions';
import { Step } from '../models/Step';
import { STORE_STEP, CLEAR_STEPS, SET_ACTIVE_STEP } from '../constants/Constants';

export const storeStep = (title: string, formName : string) => action(STORE_STEP, 
  {
    title : title, 
    formName : formName
  } as Step);

export const clearStep = () => action(CLEAR_STEPS);

export const setActiveStepForm = (stepFormName : string) => action(SET_ACTIVE_STEP, 
  {
    stepFormName : stepFormName
  });